module.exports = __webpack_public_path__ + "img/ma.9d76a14d.svg";